/** Built-in value references. */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own symbol properties of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = getOwnPropertySymbols || function() {
  return [];
};

module.exports = getSymbols;



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-touch/node_modules/lodash/_getSymbols.js
// module id = ./node_modules/react-touch/node_modules/lodash/_getSymbols.js
// module chunks = main